<template>
  <v-row>
    <v-col cols="12">
      <v-card
        class="mb-5"
        outlined
        :loading="participant_damage_claims.length == 0"
      >
        <v-card-title>{{ $capitalize($tc("model.damages_coverage_consumption")) }}</v-card-title>
        <empty-state
          :when="lead.used_coverages && lead.used_coverages.length == 0"
          :message="$capitalize($tc('model.damages_budget_no_registered'))"
        >
          <v-simple-table>
            <thead>
              <tr>
                <th>{{ $capitalize($tc("model.damages_coverage")) }}</th>
                <th></th>
                <th>{{ $capitalize($tc("model.damages_budgeted")) }}</th>
                <th>{{ $capitalize($tc("model.damages_franchise")) }}</th>
                <th>{{ $capitalize($tc("model.damages_safe_value")) }}</th>
                <th>{{ $capitalize($tc("model.damages_available")) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="coverage in lead.used_coverages" :key="coverage.id">
                <td width="20%">{{ coverage.type_description }}</td>
                <td width="20%">
                  <v-progress-linear
                    :color="
                      coverage.total_budget > total_to_spend(coverage)
                        ? 'red darken-1'
                        : 'primary'
                    "
                    :value="
                      (coverage.total_budget / total_to_spend(coverage)) * 100
                    "
                  />
                </td>
                <td>{{ formatEuro(coverage.total_budget) }}</td>
                <td width="20%">
                  <span v-if="coverage.franchise > 0">{{
                    formatEuro(coverage.franchise)
                  }}</span>
                  <money-input
                    v-else
                    v-model="coverage.franchise_internal"
                    name="price"
                    type="text"
                    dense
                    hide-details
                    :options="money"
                  >
                    <template v-slot:append>
                      <v-btn
                        icon
                        :loading="coverage.id == saving_coverage_id"
                        @click="setNewFranchiseValue(coverage)"
                      >
                        <v-icon>mdi-content-save-edit-outline</v-icon>
                      </v-btn>
                    </template>
                  </money-input>
                </td>
                <td>{{ formatEuro(coverage.capital) }}</td>
                <td>{{ formatEuro(total_available(coverage)) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </empty-state>
      </v-card>
      <ParticipantDamageClaim
        v-for="participant in participant_damage_claims"
        :key="participant.id"
        :participant="participant"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
import Money from "@/tools/money";
import EmptyState from "@/components/EmptyState";
import MoneyInput from "@/components/MoneyInput";
import ParticipantDamageClaim from "@/components/Lead/ParticipantDamageClaim";
import { updateFranchise, calcTotalToSpend } from "@/services/policy_coverage";
import { indexDamageClaims, damage_classification } from "@/services/damages";

export default {
  components: { EmptyState, MoneyInput, ParticipantDamageClaim },
  data: () => ({
    loading: false,
    saving_coverage_id: null,
    participants_damage_claims: [],
    money: {
      prefix: "€ ",
      suffix: "",
      precision: 2,
      length: 11,
      locale: "pt-PT"
    }
  }),
  methods: {
    formatEuro(value) {
      return Money.euro(value);
    },
    async setNewFranchiseValue(coverage) {
      this.saving_coverage_id = coverage.id;
      try {
        await updateFranchise(coverage.id, {
          franchise_internal: coverage.franchise_internal
        });
      } catch (e) {
        coverage.errors = e.response.data.errors.franchise;
      } finally {
        this.saving_coverage_id = null;
      }
    },
    total_to_spend(coverage) {
      return calcTotalToSpend(coverage);
    },
    total_available(coverage) {
      return this.total_to_spend(coverage) - coverage.total_budget;
    },
    ...mapActions("room_types", ["loadRoomTypes"]),
    ...mapActions("damage_claim", ["loadDamageTypes"]),
    ...mapActions("damage_claim", ["clearParticipants"]),
    ...mapActions("damage_claim", ["loadDamageClaims"]),
    ...mapActions("room_forfaits", ["loadRoomForfaits"])
  },
  computed: {
    lead: function() {
      return this.$store.getters.getLead;
    },
    participant_damage_claims: function() {
      return this.$store.getters["damage_claim/getParticipants"];
    }
  },
  created() {
    this.loadRoomTypes();
    this.loadDamageTypes();
    this.clearParticipants();
    this.loadDamageClaims(this.$route.params["lead_number"]);
    this.loadRoomForfaits();
  }
};
</script>
